import { createFileRoute } from "@tanstack/react-router";
import ProductLanding from "@/pages/ProductLanding";

export const Route = createFileRoute("/cordless-leaf-blower")({
  component: ProductLanding,
});
